import type { OrderStatus } from '@/types/enums'
import type { FeedEvent, Order } from '@/types/order'
import i18n from '@/utils/i18n'

export function tickerStatusPhrase(status: OrderStatus): string {
  return i18n.t(`ticker.${status}`)
}

/** Формат TICKER_SPEC: «Марка Модель — описание» */
export function formatTickerChipLine(ev: FeedEvent, order: Order | undefined): string {
  if (order && ev.status) {
    const phrase = tickerStatusPhrase(ev.status)
    if (phrase) {
      return `${order.brand} ${order.model}: ${phrase}`
    }
  }
  return ev.summary
}
